import { defineComponent as a, createElementBlock as r, openBlock as t, mergeProps as n, createCommentVNode as d, createElementVNode as l, renderSlot as o } from "vue";
import { COMPONENT_NAME as i } from "./highrise178.mjs";
const c = {
  key: 0,
  class: "hr-card-header"
}, u = { class: "hr-card-content" }, f = {
  key: 1,
  class: "hr-card-footer"
}, h = a({
  name: i.CARD,
  inheritAttrs: !1
}), y = /* @__PURE__ */ a({
  ...h,
  props: {
    id: {
      type: String,
      required: !0
    },
    borderType: {
      type: [String, Boolean],
      default: !1
    }
  },
  setup(s) {
    return (e, m) => (t(), r("div", n(e.$attrs, {
      class: ["hr-card", s.borderType ? `${s.borderType}` : ""]
    }), [
      e.$slots.header ? (t(), r("div", c, [
        o(e.$slots, "header", {}, void 0, !0)
      ])) : d("", !0),
      l("div", u, [
        o(e.$slots, "default", {}, void 0, !0)
      ]),
      e.$slots.footer ? (t(), r("div", f, [
        o(e.$slots, "footer", {}, void 0, !0)
      ])) : d("", !0)
    ], 16));
  }
});
export {
  y as default
};
